// extracted by mini-css-extract-plugin
var _1 = "phoneNumber-module__phoneNumber___YH1N8";
var _2 = "phoneNumber-module__roundedButton___dA7Qk";
export { _1 as "phoneNumber", _2 as "roundedButton" }
